// @ts-nocheck
const isUrlParams = window.location.search === "" ? false : true;

const languages = {
  en: "English",
  "de-de": "Deutsch anzeigen",
  "es-es": "Español (España)",
  "es-mx": "Español (Latinoamérica)",
  "pt-br": "Português",
  "fr-fr": "Français",
  "it-it": "Italiano",
  "ja-jp": "日本語で見る",
  "ko-ko": "웹사이트 보기",
  "ru-ru": "русском языке",
  "tr-tr": "Türkçe görüntüleyin",
  "zh-cn": "观看网站",
  "zh-tw": "觀看網站",
  "cz-cz": "češtině",
  "pl-pl": "Polskim",
};

const otherLangs = {
  en: "Other Languages",
  "de-de": "Weitere Sprachen",
  "es-es": "Otros idiomas",
  "es-mx": "Otros idiomas",
  "pt-br": "Outros idiomas",
  "fr-fr": "Autres langues",
  "it-it": "Altre lingue",
  "ja-jp": "他の言語",
  "ko-ko": "기타 언어",
  "ru-ru": "Другие языки",
  "tr-tr": "Diğer Diller",
  "zh-cn": "其它语言",
  "zh-tw": "其他語言",
  "cz-cz": "Další jazyky",
  "pl-pl": "Inne języki",
};

export async function setCookies(result) {
  let requestOptions, ssoLoginUrl;

  if(result.idToken.payload["custom:geId"]){
    requestOptions = {
      method: "POST",
      redirect: "follow",
      credentials: "include",
      body: JSON.stringify({
        idToken: result.getIdToken().getJwtToken(),
        accessToken: result.getAccessToken().getJwtToken(),
        refreshToken: result.getRefreshToken().getToken(),
      }),
    };

    ssoLoginUrl = isUrlParams
    ? `${process.env.REACT_APP_GE_BASE_URL}/ssologin${window.location.search}`
    : `${process.env.REACT_APP_GE_BASE_URL}/ssologin`;
  }else{
    requestOptions = {
      method: "POST",
      redirect: "follow",
      credentials: "include",
      headers: {
        authorization: result.getIdToken().getJwtToken(),
      },
      body: JSON.stringify({
        idToken: result.getIdToken().getJwtToken(),
        accessToken: result.getAccessToken().getJwtToken(),
        refreshToken: result.getRefreshToken().getToken(),
      }),
    };

    ssoLoginUrl = isUrlParams
      ? `${process.env.REACT_APP_API_GATEWAY_URL}/ssologin${window.location.search}`
      : `${process.env.REACT_APP_API_GATEWAY_URL}/ssologin`;
  }
  
  window.localStorage.clear()

  

  const response = fetch(ssoLoginUrl, requestOptions)
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      if (response.redirected) {
        const err = {
          code: "SETCOOKIEFAILURE",
          name: "FAILEDTOSETCOOKIE",
          message: "Something went wrong.",
        };
        return { response: null, error: err };
      }
    })
    .then((data: any) => {
      if (data) {
        return { response: data, error: null };
      }
    })
    .catch((error) => {
      return { data: null, error };
    });
  return response;
}

export const getCookieValue = (key) => {
  const value = document.cookie.match(`(^|;)\\s*${key}\\s*=\\s*([^;]+)`);
  return value ? value.pop() : "";
};

export const getLangFromCode = (langCode) => {
  return languages[langCode.toLowerCase()];
};

export const getOtherLangFromCode = (langCode) => {
  return otherLangs[langCode.toLowerCase()];
};
